import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { PillType } from 'src/app/shared/components/pill/pill.model';
import { PillComponent } from '@components';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-optimization-setting-option',
  standalone: true,
  imports: [PillComponent, MatSlideToggleModule, CommonStandaloneModule, MatIconModule],
  templateUrl: './optimization-setting-option.component.html',
  styleUrls: ['./optimization-setting-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationSettingOptionComponent {
  readonly pillType = PillType;
  @Input({ required: true }) disabledToggle = false;
  @Input({ required: true }) title: string;
  @Input({ required: true }) description: string;
  @Input() isSubscriptionActive: boolean;
  @Input({ required: true }) checked: boolean;
  @Input({ required: true }) isShowPill: boolean;
  @Input() subscriptionLabel: string;
  @Output() toggleChange = new EventEmitter<MatSlideToggleChange>();
}
